import { Link } from 'react-router-dom';

export default function CtaSection() {
  return (
    <section className="relative py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20turquoise%20teal%20ocean%20water%20surface%20light%20reflection%20ripples%20waves%20digital%20technology%20glowing%20particles%20underwater%20scene%20with%20soft%20bokeh%20effect%20clean%20minimal%20background%20for%20IT%20company%20website%20call%20to%20action%20section&width=1920&height=600&seq=ocean-cta-01&orientation=landscape"
          alt="CTA background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-teal-900/80 to-cyan-900/70"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 md:px-8 text-center">
        <p className="text-teal-200 text-xs font-semibold uppercase tracking-widest mb-4">Contact Us</p>
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4 leading-tight" style={{ fontFamily: "'Montserrat', sans-serif" }}>
          まずは、お気軽に<br />ご相談ください
        </h2>
        <p className="text-white/70 text-sm md:text-base max-w-xl mx-auto mb-8 leading-relaxed">
          システム開発・アプリ開発・Webサービスについて、<br className="hidden md:block" />
          どんな小さなご相談でも歓迎です。無料でご相談を承ります。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/contact"
            className="px-8 py-3 rounded-full bg-white text-teal-700 font-semibold text-sm whitespace-nowrap cursor-pointer hover:bg-teal-50 transition-colors"
          >
            無料相談・お問い合わせ
          </Link>
          <a
            href="tel:08044800273"
            className="px-8 py-3 rounded-full border border-white/40 text-white font-semibold text-sm whitespace-nowrap cursor-pointer hover:bg-white/10 transition-colors flex items-center gap-2"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-phone-line text-sm"></i>
            </div>
            080-4480-0273
          </a>
        </div>
      </div>
    </section>
  );
}
